<template>
  <div class="show" style="background: #f3f3f3">
    <headbox></headbox>
    <div class="assreboxo">
      <p>
        当前位置：<router-link to="/jqql?id=110" v-if="geththd">专题活动&nbsp;>&nbsp;</router-link>
        <router-link to="/gjj?id=2000" v-if="getcyzc">产业政策&nbsp;>&nbsp;</router-link>
        <router-link to="/qyfw?id=120" v-if="getcyfw">产业服务&nbsp;>&nbsp;</router-link>
        <span>{{ this.connt.siteCateName[5] }}</span>
      </p>
    </div>
    <div class="searchbox">
      <div class="seabl">

        <div class="sercont">
          <h2>{{ connt.title }}</h2>
          <h4>
            <span v-if="connt.createTime">日期: <span class="tnottime">{{ connt.createTime }}</span></span>
            <span v-if="connt.source">来源: <span class="tnottime">{{ connt.source }}</span></span
            ><span v-if="connt.organName">作者: <span class="tnottime">{{ connt.organName }}</span></span
            ><span v-if="connt.pv">浏览: <span class="tnottime">{{ connt.pv }}次</span></span>
            <span class="fzlj" style="color: #346cc6" @click="fzlj">复制文章链接</span>
            <span class="fxqq">
              <img src="@/assets/images/qq.png" alt="" @click="shareClick('qq')" style="width: 24px; height: 24px"
            /></span>
            <span class="fxqqkj"
              ><img
                @click="shareClick('qqZone')"
                src="@/assets/images/qqz.png"
                alt=""
                style="width: 24px; height: 24px"
            /></span>
            <span class="fxwb">
              <img @click="shareClick('weibo')" src="@/assets/images/wb.png" alt="" style="width: 24px; height: 24px" />
            </span>
          </h4>
          <div class="cont" v-html="connt.content"></div>
          <div class="files"  v-show="connt.files || connt.files.fujian.length">
              <div v-if="connt.files.fujian">
                <div v-for="(item,index) in connt.files.fujian"  :key="index"><a :href="item.src">{{item.fileName}}</a></div>
              </div>
              <div v-else>
                <div v-for="(item,index) in connt.files" :key="index"><a :href="item.src">{{item.fileName}}</a></div>
              </div>
          </div>
        </div>
      </div>
      <div class="searl">
        <div class="antboxre">
          <div style="margin: 0 8px">
            <div class="asslto"><span>相关资讯</span></div>
            <ul class="seabrul">
              <li v-for="item in afflist.slice(0, 5)" v-bind:key="item.id" @click="handlelitxq(item.id)">
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>
<script>
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
import moment from "moment/moment";
import { $fmtTime } from "@/utils/utils.js";
import { newss,news } from "@/api/index.js";
export default {
  name: "show",
  data() {
    return {
      connt: [],
      id: this.$route.query.id,
      windowUrl: window.location.href,
      url: this.$route.query.url,
      title: this.$route.query.title,
      // 专题活动
      geththd: false,
      // 产业政策
      getcyzc: false,
      // 产业服务
      getcyfw: false,
      // 资讯列表
      form: {
        siteid: 5,
        cate_id: 8,
        online: 1,
        enabled: 1,
        english: 0,
        page: 1,
        limit: 5,
      },
      // 资讯列表
      afflist:[],
    };
  },
  computed: {
    time() {
      return $fmtTime;
    },
  },
  components: {
    headbox,
    footbox,
  },
  created() {
     news(this.form).then((res) => {
        this.afflist = res.data.data.records;
     })
    newss(this.id).then((res) => {
      this.connt = res.data.data;
      this.connt.createTime = moment(this.connt.createTime).format("YYYY-MM-DD");

       this.connt.files = JSON.parse(this.connt.files);
        if(this.connt.files.fujian == undefined) {
          // this.connt.files = this.connt.files
          console.log(111);
        }else {
          this.connt.files.fujian.map(item => {
            if(["png","jpg","jpeg"].indexOf(item.fileName.slice(-3)) != -1) {
              item.fileName = "图片" + item.fileName.slice(0,-4)
            }
          })
        }
      // 专题活动
      if (this.connt.siteCateName[5] === "建圈强链") {
        this.geththd = true;
      }
      if (this.connt.siteCateName[5] === "20+系列活动") {
        this.geththd = true;
      }
      // 产业政策
      if (this.connt.siteCateName[5] === "国家级") {
        this.getcyzc = true;
      }
      if (this.connt.siteCateName[5] === "四川级") {
        this.getcyzc = true;
      }
      if (this.connt.siteCateName[5] === "成都市") {
        this.getcyzc = true;
      }
      // 产业服务
      if (this.connt.siteCateName[5] === "企业服务") {
        this.getcyfw = true;
      }
      if (this.connt.siteCateName[5] === "行业统计") {
        this.getcyfw = true;
      }
      if (this.connt.siteCateName[5] === "“蓉贝”人才") {
        this.getcyfw = true;
      }
      if (this.connt.siteCateName[5] === "软洽会") {
        this.getcyfw = true;
      }
      if (this.connt.siteCateName[5] === "软件大赛") {
        this.getcyfw = true;
      }
      if (this.connt.siteCateName[5] === "信息通信大会") {
        this.getcyfw = true;
      }
    });
  },
  methods: {
    handlelitxq(id) {
      this.$router.push({ path: '/show', query: { id: id } });
      location.reload();
    },
    fn(id) {
      const obj = {
        100: "/cdgk",
        101: "fzhj",
        102: "cycj",
      };
      this.$router.push({ path: obj[id], query: { id } });
    },
    shareClick: function (type) {
      if (type !== "wechat") {
        let summary = "";
        let info = {
          url: window.location.href,
          summary,
        };
        info.title = "biaoti";
        info.desc = "jjjj";
        this.jumpUrl(type, info);
      }
    },
    jumpUrl(type, info) {
      let jumpurl = window.location.href;
      let urlList = {
       qq:
         'http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(jumpurl) +
         "&desc=" + this.connt.title + this.connt.summary + encodeURIComponent(jumpurl) +
         "&title=" + this.connt.title +
         "&summary=" + this.connt.summary,
       weibo:
         "http://service.weibo.com/share/share.php?url="+ encodeURIComponent(jumpurl) +
         "&desc=" + this.connt.title + this.connt.summary + encodeURIComponent(jumpurl) +
         "&title=" + this.connt.title +
         "&summary=" + this.connt.summary,
       qqZone:
          "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url="+ encodeURIComponent(jumpurl) +
          "&desc=" + this.connt.title + this.connt.summary + encodeURIComponent(jumpurl) +
          "&title=" + this.connt.title +
          "&summary=" + this.connt.summary,
      };

      if (urlList[type] && urlList[type].length) {
        // 替换url
        const shareUrl = urlList[type].replace(/{{(\w+)}}/g, (match, p1) => {
          return encodeURIComponent(info[p1] || '');
        });
        // 获取窗口的宽高
        const screenInfo = window.screen;
        const newWindowArea = {
          height: (screenInfo.height / 3) * 2,
          width: (screenInfo.width / 3) * 2
        };
        // 打开窗口
        window.open(shareUrl, 'newwindow', `height=${newWindowArea.height}, width=${newWindowArea.width}`);
      } else {
        console.warn('url不存在');
      }
    },
    fzlj() {
      let domUrl = document.createElement('input');
      domUrl.value = this.windowUrl;
      domUrl.id = 'creatDom';
      document.body.appendChild(domUrl);
      domUrl.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      let creatDom = document.getElementById('creatDom');
      creatDom.parentNode.removeChild(creatDom);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
  },
  mounted() {
    let imgs = [];
    let timer = setInterval(() => {
      imgs = document.querySelectorAll('.cont img');
      if (imgs.length) {
        clearInterval(timer);
        imgs.forEach(item => {
          if (item.offsetWidth > 920) {
            item.style.width = '90%';
          }
        });
      }
      setTimeout(() => {
        clearInterval(timer);
      }, 3000);
    }, 500);

    let isChange = true;
    function contimg() {
      if (document.documentElement.clientWidth < 970) {
        if (isChange) {
          imgs.forEach(item => {
            item.style.width = '90%';
          });
          isChange = false;
        }
      } else {
        isChange = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.asslto{
  width:100%;
  border-bottom: 1px solid #dadada;
}
.asslto >span{
  font-size:20px;
  padding:0 8px;
  color:#ff9900;
  border-bottom:2px solid #ff9900;
  // margin-top:30px;
  display: inline-block;
  padding-bottom: 5px;
}
 .seabrul{
    color: #525252;
    font-size:15px;
    font-family: Microsoft YaHei;
    padding:0 10px 0 20px;
 }
  .seabrul>li{
    margin:8px 0;
    cursor: pointer;
    list-style: decimal;
  }
  .seabrul >li:hover{
    color:#ff9900
  }
  .seabrul>li >a{
    text-decoration: none;
    color: #7A7A7A;
  }


.tnottime{
  font-weight: normal;
}
.fzlj {
  cursor: pointer;
}
.fxqq {
  cursor: pointer;
}
.fxqqkj {
  cursor: pointer;
}
.fxwb {
  cursor: pointer;
}
@media screen and (max-width: 600px) {
  .fzlj {
    display: none;
  }
  .fxqq {
    display: none;
  }
  .fxqqkj {
    display: none;
  }
  .fxwb {
    display: none;
  }
}
.searchbox {
  max-width: 1200px;
  // min-width: 350px;
  margin: 0 auto;
  display: flex;
  background:#fff;
  text-align: left;
  // margin-top: 20px;
}
.searl {
  flex: 2.5;
  margin: 20px 30px 0 0;
   @media screen and (max-width:800px) {
    display: none;
  }
}
.seabl {
  flex: 7.5;
  max-width:960px;
  // min-height: 1200px;
}
.seabl > p > a {
  color: #ff9900;
}
.seabl > p {
  color: #ff9900;
  padding-left: 15px;
}
.sertit {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  padding-left: 15px;
}
.searl > ul {
  margin-top: 11px;
}
.searl > ul > li {
  height: 39px;
  padding-left: 15px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 39px;
  font-size: 16px;
  color: #7a7a7a;
}
.searl > ul > li > span {
  float: right;
  color: #e4e4e4;
}
#serlistbox {
  background: #42a5f6;
  color: #fff;
}
.dqwz {
  margin-left: 64px;
}
.dqwz > a {
  color: #ff9900;
}
.sercont {
  margin: 20px;
  box-sizing:inherit;
}
.sercont > h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 22px;
}
.sercont > h4 {
  color: #525252;
  font-size: 12px;
  margin-top: 20px;
  padding-bottom: 10px;
}
.cont {
  // color: #7a7a7a !important;
  // font-size: 16px !important;
  text-indent: 2rem;
  padding: 0 15px;
  margin: 15px 0 50px 0;
}
.seabtnbox {
  margin-top: 30px;
  text-align: center;
}
.seabtnbox > button {
  border: 2px solid #00aaeb;
  color: #00aaeb;
  border-radius: 10pt 10pt 10pt 10pt;
  height: 42px;
  width: 126px;
  font-size: 20px;
  background: #fff;
  margin: 0 auto;
}
.sercont > h4 {
  border-bottom: 1px solid #e1e1e1;
  text-align: center;
}
.sercont > h4 > span {
  margin: 0 5px;
  font-weight: bold;
  font-size: 12px;
}
@media screen and (max-width: 900px) {
  .searl {
    display: none;
  }
  .searchbox {
    display: block;
  }
  .dqwz {
    margin-left: 15px;
    display: none;
  }
  .sercont {
    padding: 20px 15px;
    margin: 0;
  }
}
.assreboxo{
  max-width:1200px;
  margin:0 auto;
  font-family: PingFang SC-Regular;
  font-size: 16px;
  background: #fff;
  padding:15px;
  text-align: left;
  @media screen and (max-width:800px){
    display: none;
  }
  }
.assreboxo >p{
  max-width:1200px;
  margin:0 auto;
}
.assreboxo >p >a {
  color: #000;
}
</style>
<style>
pre {
  white-space: pre-wrap;
}
.cont {
  /* color: #7a7a7a !important; */
  /* font-size: 16px !important; */
  text-indent: 2rem;
}
.cont > div {
  /* color: #7a7a7a !important; */
  /* font-size: 16px !important; */
  text-indent: 2rem;
}
.cont > div > p {
  /* color: #7a7a7a !important; */
  /* font-size: 16px !important; */
  text-indent: 2rem;
}
.files a {
    color:#346cc6;
}
.files a:visited {
    color:#346cc6;
}

</style>
<style>
.cont >p >img {
  max-width: 100%;
  /* height: auto !important; */
  object-fit: scale-down;
  display: block;
}
.cont >p > span >img {
  max-width: 100%;
  /* height: auto !important; */
  object-fit: scale-down;
  display: block;
}
.ql-align-center > img {
  margin: 0 auto;
}
</style>

